module.exports = __webpack_public_path__ + "static/media/lollipop.30a6460a.png";